import type {ReactElement} from 'react';
import React from 'react';
import type {PlanTableProps} from './plan-table.types';
import styles from './plan-table.module.scss';

export function PlanTable({steps}: PlanTableProps): ReactElement {
  return (
    <div className={styles.planTable}>
      {steps.map((step) => (
        <div key={step.number} className={styles.row}>
          <div className={styles.stepNumber}>{step.number}</div>
          <div className={styles.description}>{step.description}</div>
        </div>
      ))}
    </div>
  );
}
